import { Box } from "@mui/material";
import Toast from "components/atomics/Toast";
import PLButton from "components/patternLib/PLButton";
import PLDropzone from "components/patternLib/PLDropzone";
import PLImage from "components/patternLib/PLImage";
import PLModal from "components/patternLib/PLModal";
import React from "react";
import translations from "translations";
import { useHandleSavePhoto } from "./useHandleSavePhoto";

interface Props {
  afterMutation: () => Promise<void>;
  assetId: string;
  dropzoneModalOpen: boolean;
  setDropzoneModalOpen: (value: boolean) => void;
}
const PhotoUpload: React.FC<Props> = ({ assetId, afterMutation, setDropzoneModalOpen, dropzoneModalOpen }) => {
  const {
    file,
    handleUploadedPictures,
    convertImageToBase64,
    clearImage,
    clearStates,
    toastObject,
    saveImage,
    handleCloseToast,
    image,
  } = useHandleSavePhoto({ assetId, afterMutation, setDropzoneModalOpen });

  return (
    <>
      {dropzoneModalOpen && (
        <PLModal
          modalTitle={translations.pages.assetManagement.assetDetails.dropZoneModalTitle}
          show={dropzoneModalOpen}
          lhClose={clearStates}
          hideSubmit
          hideCancel
          allowCloseOnBackdrop
        >
          <Box slot="modal-content">
            <Box>
              {!image ? (
                <PLDropzone
                  label={translations.pages.assetManagement.assetDetails.dropzoneButtonLabel}
                  acceptedFiles="PNG, JPG, GIF"
                  width="100%"
                  dropzoneLabel={translations.pages.assetManagement.assetDetails.uploadImageDropzoneLabel}
                  lhChange={handleUploadedPictures}
                  showDefaultSubmitButton={false}
                />
              ) : (
                <PLImage src={image} objectFit="contain" alt="image" width="100%" height="250px" />
              )}
              <Box sx={{ display: "flex", flexDirection: "row-reverse", marginTop: "25px", gap: "1.5rem" }}>
                <PLButton
                  label={!image ? translations.globals.button.continue : translations.globals.button.save}
                  disabled={!file}
                  onClick={
                    image
                      ? saveImage
                      : async () => {
                          await convertImageToBase64(file as File);
                        }
                  }
                />
                {image ? (
                  <PLButton type="secondary" label={translations.globals.button.back} onClick={() => clearImage()} />
                ) : null}
              </Box>
            </Box>
          </Box>
        </PLModal>
      )}
      {toastObject && (
        <Toast
          message={toastObject.message}
          open={toastObject.open}
          severity={toastObject.severity}
          handleCloseToast={handleCloseToast}
        />
      )}
    </>
  );
};

export default PhotoUpload;
